import { __read } from "tslib";
var languages = {
    en: { name: 'English (US)', fullLang: 'en-US', tier: 1 },
    'en-gb': { name: 'English (UK)', fullLang: 'en-GB', tier: 1 },
    bg: { name: 'Български', fullLang: 'bg-BG', tier: 1 },
    ca: { name: 'Català', fullLang: 'ca-ES', tier: 2 },
    cs: { name: 'Čeština', fullLang: 'cs-CZ', tier: 1 },
    da: { name: 'Dansk', fullLang: 'da-DK', tier: 1 },
    de: { name: 'Deutsch', fullLang: 'de-DE', tier: 1 },
    fr: { name: 'Français', fullLang: 'fr-FR', tier: 1 },
    'fr-ca': { name: 'Français (Canada)', fullLang: 'fr-CA', tier: 1 },
    es: { name: 'Español', fullLang: 'es-ES', tier: 1 },
    'es-la': { name: 'Español (Latinoamérica)', fullLang: 'es-LA', tier: 1 },
    el: { name: 'Ελληνικά', fullLang: 'el-GR', tier: 1 },
    he: { name: 'עִבְרִית', fullLang: 'he-IL', tier: 2 },
    hr: { name: 'Hrvatski', fullLang: 'hr-HR', tier: 1 },
    id: { name: 'Bahasa Indonesia', fullLang: 'id-ID', tier: 1 },
    it: { name: 'Italiano', fullLang: 'it-IT', tier: 1 },
    kk: { name: 'Қазақша', fullLang: 'kk-KZ', tier: 2 },
    lv: { name: 'Latviešu', fullLang: 'lv-LV', tier: 2 },
    lt: { name: 'Lietuvių', fullLang: 'lt-LT', tier: 2 },
    hu: { name: 'Magyar', fullLang: 'hu-HU', tier: 1 },
    ms: { name: 'Bahasa Melayu', fullLang: 'ms-MY', tier: 1 },
    nl: { name: 'Nederlands', fullLang: 'nl-NL', tier: 1 },
    no: { name: 'Norsk', fullLang: 'no-NO', tier: 1 },
    pl: { name: 'polski', fullLang: 'pl-PL', tier: 1 },
    pt: { name: 'Português', fullLang: 'pt-PT', tier: 2 },
    'pt-br': { name: 'Português (Brasil)', fullLang: 'pt-BR', tier: 1 },
    sl: { name: 'slovenščina', fullLang: 'sl-SI', tier: 1 },
    fi: { name: 'Suomi', fullLang: 'fi-FI', tier: 1 },
    ro: { name: 'Română', fullLang: 'ro-RO', tier: 1 },
    ru: { name: 'Русский', fullLang: 'ru-RU', tier: 1 },
    sv: { name: 'Svenska', fullLang: 'sv-SE', tier: 1 },
    sk: { name: 'Slovenčina', fullLang: 'sk-SK', tier: 1 },
    sr: { name: 'srpski (latinica)', fullLang: 'sr-RS', tier: 2 },
    tr: { name: 'Türkçe', fullLang: 'tr-TR', tier: 1 },
    th: { name: 'ภาษาไทย', fullLang: 'th-TH', tier: 1 },
    uk: { name: 'Українська', fullLang: 'uk-UA', tier: 1 },
    vi: { name: 'Tiếng Việt', fullLang: 'vi-VN', tier: 1 },
    ja: { name: '日本語', fullLang: 'ja-JP', tier: 1 },
    'zh-tw': { name: '繁體中文', fullLang: 'zh-TW', tier: 1 },
    'zh-cn': { name: '中文', fullLang: 'zh-CN', tier: 1 },
    ko: { name: '한국어', fullLang: 'ko-KR', tier: 1 },
    rigi: { name: 'Rigi', fullLang: 'rigi', tier: 2 },
    ar: { name: 'العربية', fullLang: 'ar-SA', tier: 2 }
};
export var languageNames = Object.keys(languages).map(function (key) {
    var _a;
    return (_a = {}, _a[key] = languages[key].name, _a);
});
export var longLangCodes = Object.fromEntries(Object.entries(languages).map(function (_a) {
    var _b = __read(_a, 2), k = _b[0], v = _b[1];
    return [k, v.fullLang];
}));
export var languageCodes = Object.keys(languages);
// Overrides if concur lang code does not match moment lang code
export var momentOverrides = {
    // Concur: Moment
    no: 'nb'
};
export var momentLanguageCodes = Object.keys(languages).map(function (key) { return momentOverrides[key] || key; });
export default languages;
